import NameRedirect from './container'

export default NameRedirect
